<template>
  <div class="main">
    <router-view v-slot="{ Component, route }">
      <keep-alive :include="['IndexPage']">
        <component :is="Component" :key="route.meta.keepAlive ? route.name : route.fullPath" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss" scoped>
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-image: url('./resource/bg2.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
